export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  articleCount: number;
  imageUrl: string;
}

export const categories: Category[] = [
  {
    id: 'cat-1',
    name: '欧美一区',
    slug: 'zone-one',
    description: '欧美一区汇聚最热门欧美影视资源，涵盖院线大片、高分剧集、经典老片，为您提供极致高清观影导航体验。',
    icon: 'ri-movie-2-line',
    articleCount: 128,
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20cinematic%20visual%20with%20warm%20golden%20lighting%2C%20luxurious%20theater%20atmosphere%2C%20soft%20film%20grain%20texture%2C%20Hollywood%20blockbuster%20aesthetic%2C%20rich%20amber%20and%20deep%20red%20tones%2C%20elegant%20minimal%20composition%2C%20movie%20screen%20glow%20effect&width=600&height=450&seq=cat-zone-one&orientation=landscape',
  },
  {
    id: 'cat-2',
    name: '欧美二区',
    slug: 'zone-two',
    description: '欧美二区专注独立电影、文艺片、纪录片及小众精品，探索欧美影视的深度与多元魅力。',
    icon: 'ri-film-line',
    articleCount: 96,
    imageUrl: 'https://readdy.ai/api/search-image?query=Artistic%20film%20festival%20visual%20with%20moody%20atmospheric%20lighting%2C%20vintage%20cinema%20camera%20aesthetic%2C%20warm%20sepia%20tones%2C%20independent%20film%20texture%2C%20soft%20focus%20background%2C%20European%20arthouse%20cinema%20style%2C%20elegant%20composition&width=600&height=450&seq=cat-zone-two&orientation=landscape',
  },
  {
    id: 'cat-3',
    name: '动作冒险',
    slug: 'action-adventure',
    description: '热血沸腾的动作大片、惊险刺激的冒险旅程，好莱坞顶级特效与震撼场面一网打尽。',
    icon: 'ri-rocket-2-line',
    articleCount: 85,
    imageUrl: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20movie%20visual%20with%20explosive%20energy%2C%20warm%20fire%20and%20amber%20tones%2C%20dramatic%20contrast%20lighting%2C%20adventure%20film%20aesthetic%2C%20heroic%20silhouette%2C%20cinematic%20wide%20shot%2C%20Hollywood%20blockbuster%20style&width=600&height=450&seq=cat-action&orientation=landscape',
  },
  {
    id: 'cat-4',
    name: '科幻奇幻',
    slug: 'sci-fi-fantasy',
    description: '探索未来世界与魔幻大陆，欧美科幻巨制与奇幻史诗，带你进入超越想象的视听盛宴。',
    icon: 'ri-planet-line',
    articleCount: 72,
    imageUrl: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20visual%20with%20warm%20neon%20accents%2C%20deep%20space%20atmosphere%2C%20ethereal%20glow%20effects%2C%20cyberpunk%20aesthetic%2C%20cosmic%20color%20palette%2C%20clean%20minimal%20composition%2C%20cinematic%20sci-fi%20movie%20style&width=600&height=450&seq=cat-scifi&orientation=landscape',
  },
  {
    id: 'cat-5',
    name: '剧情悬疑',
    slug: 'drama-thriller',
    description: '扣人心弦的悬疑推理、引人深思的剧情佳作，欧美影视中最具思想深度的类型精选。',
    icon: 'ri-search-eye-line',
    articleCount: 64,
    imageUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20film%20noir%20visual%20with%20dramatic%20shadow%20play%2C%20warm%20and%20cool%20contrast%20lighting%2C%20detective%20atmosphere%2C%20suspenseful%20cinematic%20aesthetic%2C%20vintage%20European%20thriller%20style%2C%20elegant%20dark%20tones&width=600&height=450&seq=cat-drama&orientation=landscape',
  },
  {
    id: 'cat-6',
    name: '喜剧爱情',
    slug: 'comedy-romance',
    description: '轻松愉快的欧美喜剧、浪漫动人的爱情故事，为你的休闲时光增添温暖与欢笑。',
    icon: 'ri-heart-line',
    articleCount: 56,
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20romantic%20comedy%20visual%20with%20soft%20golden%20sunset%20lighting%2C%20cozy%20European%20cafe%20atmosphere%2C%20gentle%20pastel%20tones%2C%20feel-good%20movie%20aesthetic%2C%20whimsical%20Parisian%20street%20scene%2C%20lighthearted%20composition&width=600&height=450&seq=cat-comedy&orientation=landscape',
  },
];